"use client";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/utils/axios";

export const fetchExperts = createAsyncThunk(
  "experts/fetchExperts",
  async () => {
    const response = await axios.get("experts?populate=img");
    return response.data;
  },
);

const expertsSlice = createSlice({
  name: "experts",
  initialState: {
    experts: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchExperts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchExperts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.experts = action.payload;
      })
      .addCase(fetchExperts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default expertsSlice.reducer;

export const selectAllExperts = (state) => state.experts.experts;
